module.exports = __webpack_public_path__ + "img/2303.6df49510.jpg";